import React from "react";
import { FaUserAltSlash } from "react-icons/fa";
import useTranslation from "../../../hooks/use-translation";
import Swal from 'sweetalert2';
import { MdDelete } from "react-icons/md";
const BlockUserItem = (props) => {
    const { translate, direction } = useTranslation();
    const confirmationBlockHandle = () => {
        return Swal.fire({
            icon: "warning",
            html: `<div class="pe-10 ps-10 fw-bolder">${translate(`confirmation_question-${props.listKey == 'block_user' ? 'blocked' : 'delete-chat'}`)}</div>`,
            buttonsStyling: false,
            showCancelButton: true,
            cancelButtonText: translate('no'),
            showLoaderOnConfirm: true,
            confirmButtonText: translate('yes'),
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-light-danger"
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                props.onBlockUser();
            }
        });
    };
    return (React.createElement("li", { onClick: confirmationBlockHandle, className: "list__dropdown-li d-flex cursor-pointer grayHoverBg d-flex justify-content-center align-items-center gap-1" },
        props.listKey == 'block_user' ? React.createElement(FaUserAltSlash, { style: { fontSize: "16px" } }) :
            React.createElement(MdDelete, { style: { fontSize: "16px" } }),
        React.createElement("div", { className: "list__dropdown-li-div" },
            React.createElement("span", { className: "list__dropdown-li-span d-flex" }, translate(props.listKey)))));
};
export default BlockUserItem;
